import { defineStore } from 'pinia'

export const useUiToggleStore = defineStore('uiToggle', {
  state: () => ({
    showNewUI: false
  }),

  actions: {
    setShowNewUI(value) {
      this.showNewUI = value
    },
    toggleUI() {
      this.showNewUI = !this.showNewUI
    }
  },

  persist: true
})
